import { useSyncExternalStore } from 'react'
import { cn } from '@/lib/cn'
import styles from './ToastViewport.module.css'
import { getToastSnapshot, remove, subscribeToToasts } from './toast-store.ts'

function getEmptyToastSnapshot() {
  return [] as ReturnType<typeof getToastSnapshot>
}

export function ToastViewport() {
  const toasts = useSyncExternalStore(subscribeToToasts, getToastSnapshot, getEmptyToastSnapshot)

  if (toasts.length === 0) {
    return null
  }

  return (
    <div className={styles.viewport} aria-live="polite" aria-atomic="false" role="region">
      {toasts.map((toast) => (
        <article
          key={toast.id}
          className={cn(styles.toast, styles[toast.variant], styles[toast.state])}
          role={toast.variant === 'error' ? 'alert' : 'status'}
        >
          <div className={styles.content}>
            <p className={styles.title}>{toast.title}</p>
            {toast.description && <p className={styles.description}>{toast.description}</p>}
          </div>
          <button type="button" className={styles.close} aria-label="بستن پیام" onClick={() => remove(toast.id)}>
            x
          </button>
        </article>
      ))}
    </div>
  )
}
